module.exports = __webpack_public_path__ + "img/training-3.a5462275.jpg";